export default function getChangeLogName(name: string) {
  let nameValue;

  switch (name) {
    case 'consumerStatus':
      nameValue = 'Consumer status:';
      break;
    case 'baseellaStatus':
      nameValue = 'Baseella status:';
      break;
    case 'benificiaryType':
      nameValue = 'Benificiary Type:';
      break;
    case 'paymentType':
      nameValue = 'Payment Type:';
      break;
    case 'id':
      nameValue = 'ID:';
      break;
    case 'createdAt':
      nameValue = 'Created At:';
      break;
    case 'updatedAt':
      nameValue = 'Updated At:';
      break;
    case 'deletedAt':
      nameValue = 'Deleted At:';
      break;
    case 'acceptedIn':
      nameValue = 'Accepted In:';
      break;
    case 'acceptedOut':
      nameValue = 'Accepted Out:';
      break;
    case 'sum':
      nameValue = 'Sum:';
      break;
    case 'sumBaseCurrency':
      nameValue = 'Sum base currency:';
      break;
    case 'email':
      nameValue = 'E-mail:';
      break;
    case 'documentNumber':
      nameValue = 'Document number:';
      break;
    case 'info':
      nameValue = 'Info:';
      break;
    case 'typeId':
      nameValue = 'Type ID:';
      break;
    case 'senderUserId':
      nameValue = 'Sender user ID:';
      break;
    case 'recipientUserId':
      nameValue = 'Recipient user ID:';
      break;
    case 'remitterName':
      nameValue = 'Remitter name:';
      break;
    case 'remitterFirstName':
      nameValue = 'Remitter first name:';
      break;
    case 'remitterLastName':
      nameValue = 'Remitter last name:';
      break;
    case 'remitterFullName':
      nameValue = 'Remitter full name:';
      break;
    case 'remitterCity':
      nameValue = 'Remitter city:';
      break;
    case 'remitterAddress':
      nameValue = 'Remitter address:';
      break;
    case 'remitterCountry':
      nameValue = 'Remitter country:';
      break;
    case 'remitterAccountNumber':
      nameValue = 'Remitter account number:';
      break;
    case 'remitterPaymentReferenceNumber':
      nameValue = 'Remitter payment reference number:';
      break;
    case 'remitterBankName':
      nameValue = 'Remitter bank name:';
      break;
    case 'remitterBankAddress':
      nameValue = 'Remitter bank address:';
      break;
    case 'remitterBankBIC':
      nameValue = 'Remitter bank BIC:';
      break;
    case 'remitterBankCountry':
      nameValue = 'Remitter bank country:';
      break;
    case 'remitterBankCorrespondentAccount':
      nameValue = 'Remitter bank correspondent account:';
      break;
    case 'benificiaryBIC':
      nameValue = 'Benificiary BIC:';
      break;
    case 'benificiaryBankSortCode':
      nameValue = 'Benificiary bank sort code:';
      break;
    case 'benificiaryBankSwiftCode':
      nameValue = 'Benificiary bank swift code:';
      break;
    case 'benificiaryBankCountry':
      nameValue = 'Benificiary bank country:';
      break;
    case 'benificiaryBankCorrespondentAccount':
      nameValue = 'Benificiary bank correspondent account:';
      break;
    case 'benificiaryBankName':
      nameValue = 'Benificiary bank name:';
      break;
    case 'benificiaryBankAddress':
      nameValue = 'Benificiary bank address:';
      break;
    case 'benificiaryFirstName':
      nameValue = 'Benificiary first name:';
      break;
    case 'benificiaryLastName':
      nameValue = 'Benificiary last name:';
      break;
    case 'benificiaryFullName':
      nameValue = 'Benificiary full name:';
      break;
    case 'benificiaryCity':
      nameValue = 'Benificiary city:';
      break;
    case 'benificiaryCountry':
      nameValue = 'Benificiary country:';
      break;
    case 'benificiaryAddress':
      nameValue = 'Benificiary address:';
      break;
    case 'intermediaryBankName':
      nameValue = 'Intermediary bank name:';
      break;
    case 'intermediaryBankCountry':
      nameValue = 'Intermediary bank country:';
      break;
    case 'intermediaryBankAddress':
      nameValue = 'Intermediary bank address:';
      break;
    case 'intermediaryBankBIC':
      nameValue = 'Intermediary bank BIC:';
      break;
    case 'intermediaryBankCorrespondentAccount':
      nameValue = 'Intermediary bank correspondent account:';
      break;
    case 'sepaBeneficiaryAccount':
      nameValue = 'SEPA beneficiary account:';
      break;
    case 'sepaBeneficiaryName':
      nameValue = 'SEPA beneficiary name:';
      break;
    case 'sepaBeneficiaryCountry':
      nameValue = 'SEPA beneficiary country:';
      break;
    case 'sepaBeneficiaryAddress':
      nameValue = 'SEPA beneficiary address:';
      break;
    case 'senderAccountNumber':
      nameValue = 'Sender account number:';
      break;
    case 'recipientAccountNumber':
      nameValue = 'Recipient account number:';
      break;
    case 'currencyId':
      nameValue = 'Currency ID:';
      break;
    case 'senderBalanceBefore':
      nameValue = 'Sender balance before:';
      break;
    case 'senderBalanceAfter':
      nameValue = 'Sender balance after:';
      break;
    case 'recipientBalanceBefore':
      nameValue = 'Recipient balance before:';
      break;
    case 'recipientBalanceAfter':
      nameValue = 'Recipient balance after:';
      break;
    case 'correspondentAccount':
      nameValue = 'Correspondent account:';
      break;
    case 'reference':
      nameValue = 'Reference:';
      break;
    case 'externalReference':
      nameValue = 'External reference:';
      break;
    case 'chargeType':
      nameValue = 'Сharge type:';
      break;
    case 'exportBatchId':
      nameValue = 'Export batch ID:';
      break;
    case 'monitoringStatus':
      nameValue = 'Monitoring status:';
      break;
    case 'riskScore':
      nameValue = 'Risk score:';
      break;
    case 'pspPartnerId':
      nameValue = 'PSP partner ID:';
      break;
    case 'pspPartnerAccountNumber':
      nameValue = 'PSP partner account number:';
      break;
    case 'feeAmount':
      nameValue = 'Fee amount:';
      break;
    case 'feeAmountBaseCurrency':
      nameValue = 'Fee amount base currency:';
      break;
    case 'exchangeDateOfRate':
      nameValue = 'Exchange Date of Rate:';
      break;
    case 'exchangeRate':
      nameValue = 'Exchange Rate:';
      break;
    case 'exchangeActualRate':
      nameValue = 'Exchange Actual Rate:';
      break;
    case 'exchangeMarginPercent':
      nameValue = 'Exchange Margin Percent:';
      break;
    case 'exchangeCurrencyFlexibleSum':
      nameValue = 'Calculated sum:';
      break;
    case 'exchangeProfit':
      nameValue = 'Exchange Profit:';
      break;
    case 'exchangeProfitRate':
      nameValue = 'Exchange Profit Rate:';
      break;
    case 'transferDate':
      nameValue = 'Transfer Date:';
      break;
    default:
      nameValue = name;
      break;
  }

  return nameValue;
}
